const conditionalRequired = conditionToTriggerRequired => (conditionToTriggerRequired ? { required: true } : {});
const addValidationWhen = (condition, validationsObject) => (condition ? validationsObject : {});

export default { conditionalRequired, addValidationWhen };
